import React, { useRef, useEffect } from 'react';
import type { TextBox } from '../types'; // Import TextBox from central types file

// Export the props interface
export interface TextBoxEditorProps {
  textBox: TextBox; // Uses TextBox defined in this file
  setTextBoxes: React.Dispatch<React.SetStateAction<TextBox[]>>;
  setSelectedTextBox: React.Dispatch<React.SetStateAction<TextBox | null>>;
  canvasSize: number;
}

const TextBoxEditor: React.FC<TextBoxEditorProps> = ({
  textBox,
  setTextBoxes,
  setSelectedTextBox,
  canvasSize,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.focus();
      textareaRef.current.select();
    }
  }, []);

  // Calculate position as percentage of canvas size
  const left = (textBox.position.x / canvasSize) * 100;
  const top = (textBox.position.y / canvasSize) * 100;
  const width = (textBox.width / canvasSize) * 100;
  const height = (textBox.height / canvasSize) * 100;

  return (
    <div
      style={{
        position: 'absolute',
        left: `${left}%`,
        top: `${top}%`,
        width: `${width}%`,
        height: `${height}%`,
        zIndex: 1000,
        pointerEvents: 'auto',
      }}
    >
      <textarea
        ref={textareaRef}
        value={textBox.content}
        onChange={(e) => {
          setTextBoxes((prev) =>
            prev.map((box) =>
              box.id === textBox.id ? { ...box, content: e.target.value } : box
            )
          );
        }}
        onBlur={() => {
          if (!textBox.content.trim()) {
            setTextBoxes((prev) => prev.filter((box) => box.id !== textBox.id));
          } else {
            setTextBoxes((prev) =>
              prev.map((box) =>
                box.id === textBox.id ? { ...box, isEditing: false } : box
              )
            );
          }
          setSelectedTextBox(null);
        }}
        style={{
          width: '100%',
          height: '100%',
          padding: '10px',
          backgroundColor: 'white',
          border: '1px solid #E2E8F0',
          borderRadius: '4px',
          fontSize: `${textBox.fontSize}px`,
          fontFamily: 'Inter, sans-serif',
          resize: 'none',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
          outline: 'none',
          color: '#1E293B',
        }}
        placeholder="Type here..."
      />
    </div>
  );
};

export default TextBoxEditor; 